// src/features/task/services/taskSubscriptions.ts
// 即時監聽：subscribeToTasks, subscribeToTasksByStatus
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { Task, TaskStatus } from '../../../types/task';
import {
  TASKS_COLLECTION,
  convertFirestoreTaskToTask,
} from './taskConverters';

// 即時監聽回調接口
export interface TaskSubscriptionCallbacks {
  onSnapshot: (tasks: Task[]) => void;
  onError: (error: Error) => void;
}

// 訂閱特定任務狀態的變更
const subscribeToTasksByStatus = (
  userId: string,
  status: TaskStatus,
  callbacks: TaskSubscriptionCallbacks
): () => void => {
  const q = query(
    collection(db, TASKS_COLLECTION),
    where('userId', '==', userId),
    where('status', '==', status),
    orderBy('createdAt', 'desc')
  );

  return onSnapshot(
    q,
    (querySnapshot) => {
      const tasks: Task[] = [];
      querySnapshot.forEach((doc) => {
        tasks.push(convertFirestoreTaskToTask(doc));
      });
      callbacks.onSnapshot(tasks);
    },
    (error) => {
      callbacks.onError(error instanceof Error ? error : new Error('監聽特定狀態任務失敗'));
    }
  );
};

// 訂閱 OPEN 任務變更（降低 Firestore 讀取量）
const subscribeToTasks = (
  userId: string,
  callbacks: TaskSubscriptionCallbacks
): () => void => {
  return subscribeToTasksByStatus(userId, 'OPEN', callbacks);
};

export const taskSubscriptionMethods = {
  subscribeToTasks,
  subscribeToTasksByStatus,
};
